import { render, staticRenderFns } from "./stageTabItem.vue?vue&type=template&id=01bfd95b"
import script from "./stageTabItem.vue?vue&type=script&lang=js"
export * from "./stageTabItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports